import { render } from "./IncidentChartMonth.vue?vue&type=template&id=0af4d03e"
import script from "./IncidentChartMonth.vue?vue&type=script&lang=js"
export * from "./IncidentChartMonth.vue?vue&type=script&lang=js"

import "./IncidentChartMonth.vue?vue&type=style&index=0&id=0af4d03e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__